<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="原始密码:" prop="origin">
          <Input v-model="formFields.origin" type="password" placeholder="请输入原始密码..." size="small" />
        </FormItem>
        <FormItem label="新密码:" prop="password">
          <Input v-model="formFields.password" type="password" placeholder="请输入新密码..." size="small" />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
const qs = require('qs')
import request from '@/utils/request'
export default {
  name: 'ResetPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    icon: {
      type: String,
      default: '"md-create'
    }
  },
  data() {
    return {
      modal: true,
      submit: false,
      formFields: { origin: '', password: '' },
      ruleValidate: {
        origin: [{ required: true, message: '原始密码不能为空!', trigger: 'blur' }],
        password: [{ required: true, message: '新密码不能为空!', trigger: 'blur' }]
      }
    }
  },
  computed: {
    action() {
      return this.$config.apiContextPath + '/me/action/resetPassword'
    },
    title() {
      return this.catch || '重置密码'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit = true
          request({
            url: this.action,
            method: 'POST',
            // data: qs.stringify(this.formFields),
            data: this.formFields
            // headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' }
          }).then(res => {
            this.$Notice.success({
              title: '密码重置成功'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(error => {
            this.submit = false
            console.log(error)
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

